<template>
  <div class="product mb-3">
    <v-card elevation="0" class="d-flex flex-column" v-if="giftData">
      <v-img
        @click="setProductDialog"
        aspect-ratio="1"
        :src="giftData.image.src"
        style="flex: 0 0 50%"
      >
      </v-img>
      <v-card-title class="justify-center pt-8 flex-column" style="position: relative;">
        <add-button 
          :isAddonFlower="addOn && isFlower"
          class="cursor-pointer" 
          :class="{'out-of-stock': isOutOfStock}" 
          :style="{'width': isOutOfStock? '12rem': '10rem'}"
          v-model="amount" 
          :actionText="!isOutOfStock? 'Select': 'Out Of Stock'" 
          :hasVariants="hasVariants" @showProductDialog="addItemWithVariation"></add-button>
        <div style="font-size: 1.4rem;" class="text-clamp-2 font-weight-bold">{{ giftData.title }}</div>
        <div class="font-weight-regular">By {{giftData.vendor}}</div>
      </v-card-title>
      <v-card-text
        style="flex: 1; font-size: 1.2rem; overflow: hidden; flex-grow: 1"
        class="text-clamp-3"
        v-if="!addOn"
      >
      {{giftData.body_html | stripHtml}}
      </v-card-text>
      <v-card-actions class="px-4">
        <del v-if="giftData.variants[0].compare_at_price" class="grey--text">RM{{giftData.variants[0].compare_at_price}}</del>
        <div class="primary--text">RM {{ giftData.variants[0].price }}</div>
        <v-spacer v-if="!addOn"></v-spacer>
        <!-- <v-btn v-if="!addOn" fab x-small color="white">
          <v-icon>mdi-heart-outline</v-icon>
        </v-btn> -->
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import AddButton from "./AddButton.vue";
import { ACTION_MODIFY_BOX } from "../../store/actions";
import {
  TYPE_SET_PRODUCT_DIALOG_ITEM,
  TYPE_SET_PRODUCT_DIALOG_TOGGLE,
} from "../../store/mutations";
export default {
  name: "hb-bab-product-card",
  components: {
    AddButton,
  },
  props: {
    giftData: Object,
    addOn: Boolean,
  },
  data(){
    return{
      actionText: 'Select'
    }
  },
  methods:{
    async addItemWithVariation(){
      const res = await this.$store.dispatch(ACTION_MODIFY_BOX, {
        product: this.giftData,
        amount: this?.amount || 1,
        boxContentType: this.boxContentType,
        variant: this.giftData.variants[0]
      });

      if(res !== false){
        this.$store.commit(TYPE_SET_PRODUCT_DIALOG_ITEM, this.giftData);
        this.showDialog = true;
      }

    },
    setProductDialog(){
      this.$store.commit(TYPE_SET_PRODUCT_DIALOG_ITEM, this.giftData);
      this.showDialog = true;
    }
  },
  computed: {
    isOutOfStock(){
      if(this.isFlower)
        return this.giftData.variants.every(variant => !variant.is_available)
      else{
        if(this.giftData.variants.length == 1 && this.giftData.variants[0].inventory_quantity <= 0)
          return true;

        return this.giftData.variants.every(variant => variant.inventory_quantity <= 0);
      }
    },
    showDialog: {
      get() {
        return this.$store.state.productDialogToggle;
      },
      set(value) {
        this.$store.commit(TYPE_SET_PRODUCT_DIALOG_TOGGLE, value);
      },
    },
    amount: {
      get() {
        const box = this.$store.state.box.find(
          (boxItem) => boxItem.id == this.giftData.id && boxItem.boxContentType == this.boxContentType
        );
        return box ? box.amount : 0;
      },
      set(amount) {
        console.log(amount,'amt')
        //TODO change to handle multiple variants
        this.$store.dispatch(ACTION_MODIFY_BOX, {
          product: this.giftData,
          amount,
          boxContentType: this.boxContentType,
          variant: this.giftData.variants[0]
        });
      },
    },
    boxContentType(){
      return this.addOn ? "boxAddons" : "boxContent";
    },
    hasVariants(){
      return this.giftData.variants.length > 1;
    },
    isFlower(){
      return this.giftData.tags.includes('flowers');
    }
  },
  filters:{
    stripHtml(string){
        return string.replace(/<\/?[^>]+>/ig, " "); 
    }
  }
};
</script>

<style scoped>
.v-card__title,
.v-card__text,
.v-card__actions {
  background: #eeeeeb;
}

.v-card__title {
  color: black;
  font-weight: 600;
}

.v-card__text {
  text-align: left;
  font-weight: 400;
  color: #666;
}

.product {
  flex: 0 0 23%;
  margin-left: 1rem;
}

@media screen and (max-width: 768px) {
  .product {
    flex: 0 0 48%;
    margin-left: 0;
  }
}
</style>